import service from '@/services/superaccess'

const authorized_type = {
  state: {
    auth_type_modal: false
  },
  mutations: {
    updateStatusAuthTypeModal (state, status) {
      state.auth_type_modal = status
    }
  },
  getters: {
    getStatusAuthTypeModal (context) {
      return context.auth_type_modal
    }
  },
  actions: {
    setStatusAuthTypeModal (context, payload) {
      context.commit('updateStatusAuthTypeModal', payload)
    },
    saveAuthorizedType (context, payload) {
      return service.post('/api/authorized_types/create', context, { authorized_type: payload.authorized_type, requireds: payload.requireds })
    },
    changeAuthTypeStatus (context, payload) {
      return service.patch('/api/authorized_types/inactive', context, payload)
    },
    setDefaultAuthorization (context, payload) {
      return service.patch('/api/authorized_types/default_authorized', context, payload)
    },
    setDefaultAccompanied (context, payload) {
      return service.patch('/api/authorized_types/default_accompanied', context, payload)
    },
    modifyAuthorizedType (context, payload) {
      return service.patch('/api/authorized_types/modify', context, { authorized_type: payload.authorized_type, requireds: payload.requireds })
    }
  }
}

export default authorized_type



// WEBPACK FOOTER //
// app/javascript/src/store/authorized_type.js